document.addEventListener("DOMContentLoaded", () => {
	const faqs = document.querySelectorAll("[data-faq]");

	[...faqs].forEach((faq) => {
		const trigger = faq.querySelector(".faq-trigger");
		const content = faq.querySelector(".faq__answer");

		trigger.addEventListener("click", () => {
			const isExpanded = trigger.getAttribute("aria-expanded") === "true";
			trigger.setAttribute("aria-expanded", !isExpanded);
			content.setAttribute("aria-hidden", isExpanded);

			trigger.style.setProperty("--before-opacity", isExpanded ? "1" : "0");
			trigger.style.setProperty("--after-opacity", isExpanded ? "0" : "1");
		});
	});
});
